import React, { useState } from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { CircularProgress, IconButton } from "@mui/material";
import toast from "react-hot-toast";
import { httpsCallable } from "firebase/functions";
import { functions } from "firebaseApp";
import { useSelector } from "react-redux";

export default function GenerateImageAltTextButton({ section, setAltText }) {

  const botState = useSelector((state) => state.bot);
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    try {
      setGenerating(true);
      const res = await httpsCallable(functions, "generateImageAltText")({
        botId: botState.current,
        documentId: section.documentId,
        sectionId: section.id,
      });
      const resData = res.data;
      if(!resData.success) {
        console.log(resData);
        toast.error(resData.error);
      } else {
        setAltText(resData.result);
      }
    } catch (error) {
      console.log(error);
      toast.error("Couldn't generate alt text.");
    } finally {
      setGenerating(false);
    }
  };

  return (
    <IconButton onClick={handleGenerate} disabled={generating}>
      {generating ? <CircularProgress size={24} /> : <AutoAwesomeIcon />}
    </IconButton>
  );
}
